import MenuButton from "@/components/menu-button";
import useTranslation from "@/hooks/use-translation";
import { Content } from "@/models/document";
import JsonView from "@uiw/react-json-view";
import React, { useEffect, useState } from "react";
import NormalizeEmbed from "./normalize-embed";

import { ContentsDisplayMode } from "@/models/widget-v2";
import { ChartDisplayMode } from "@/utils/types";
import { FaEllipsisV } from "react-icons/fa";

interface EmbedComponentProps {
  mode?: ChartDisplayMode;
  content: Content;
  displayMode?: ContentsDisplayMode;
}

const EmbedComponent: React.FC<EmbedComponentProps> = ({
  mode,
  content,
  displayMode = "normal",
}) => {
  const [itemDisplayMode, setItemDisplayMode] =
    useState<ContentsDisplayMode>(displayMode);

  // const mediaBoolean =
  // 	type.includes("dailymotion") ||
  // 	type.includes("vkontakte") ||
  // 	type.includes("snapchat")

  // const textBoolean =
  // 	type.includes("press") || type.includes("forum") || type.includes("baidu")

  const { t } = useTranslation();

  const DisplayMenuButton = () => {
    return (
      <MenuButton
        buttonContent={<FaEllipsisV />}
        menuItems={["normal", "json"] // "embed",
          .filter((item) => item !== itemDisplayMode)
          .map((item) => {
            return {
              label: t("display" + item),
              onClick: (e: React.MouseEvent) => {
                e.preventDefault();
                setItemDisplayMode(item as ContentsDisplayMode);
              },
            };
          })}
        size="sm"
      />
    );
  };

  useEffect(() => {
    setItemDisplayMode(displayMode);
  }, [displayMode]);

  return (
    <>
      {/* {itemDisplayMode === "embed" && (
				<div className={styles.embed}>
					{type.includes("facebook") && (
						<FacebookEmbed url={content.normalized.url!} />
					)}
					{type.includes("bilibili") && (
						<BilibiliEmbedRenderer aid={content.id} />
					)}
					{type.includes("instagram") && (
						<InstagramEmbed
							url={`https://www.instagram.com/p/${content.normalized.id}`}
						/>
			)}
					{type.includes("youtube") && (
						<YouTubeEmbed
							url={`https://www.youtube.com/watch?v=${content.normalized.id}`}
							width={"100%"}
							height={300}
						/>
					)}
					{type.includes("twitter") && (
						<TwitterEmbed url={content.normalized.url!} />
					)}
					{type.includes("tiktok") && (
						<TikTokEmbed url={content.normalized.url!} />
					)}
					{type.includes("linkedin") && (
						<LinkedInEmbed url={content.normalized.url!} />
					)}
					{mediaBoolean && <MediaEmbed content={content} />}
					{textBoolean && <TextEmbed content={content} />}
					<div className={styles.absoluteContainer}>
						<HateCircular sentiment={content.extra?.sentiment?.positive} />
						<DisplayMenuButton />
					</div>
				</div>
			)} */}
      {itemDisplayMode === "normal" && (
        <NormalizeEmbed
          normalized={content.normalized || content}
          sentiment={content.extra?.sentiment}
          actions={<DisplayMenuButton />}
        />
      )}
      {itemDisplayMode === "json" && (
        <div className="flex border border-arc-border p-3 w-full rounded">
          <JsonView value={content} collapsed={1} />
          <div className="absolute top-4 right-4 opacity-50 hover:opacity-100">
            <DisplayMenuButton />
          </div>
        </div>
      )}
    </>
  );
};

export default EmbedComponent;
